'use client'
import { useLayout } from '@/context/LayoutContext'

// 包裝需要隱藏的元件
export function HideableWrapper({ children }) {
  const { hideLayout } = useLayout()

  if (hideLayout) return null
  return <>{children}</>
}
